//venders
import React, { useState, useEffect } from "react"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import { Link, useHistory, useParams, useLocation } from "react-router-dom"
import { useTheme } from "@material-ui/core/styles"
import CardHeader from "@material-ui/core/CardHeader"
import AppBar from "@material-ui/core/AppBar"
import Box from "@material-ui/core/Box"
import { withStyles, makeStyles } from "@material-ui/core/styles"
import Toolbar from "@material-ui/core/Toolbar"
import IconButton from "@material-ui/core/IconButton"
import Typography from "@material-ui/core/Typography"
import Menu from "@material-ui/core/Menu"
import Container from "@material-ui/core/Container"
import Avatar from "@material-ui/core/Avatar"
import Badge from "@material-ui/core/Badge"
import Tooltip from "@material-ui/core/Tooltip"
import MenuItem from "@material-ui/core/MenuItem"
import MultiBaseDropdownList from "../../build/multiBaseDropdownList/MultiBaseDropdownList"
import BellSVG from "../../icons/BellSVG"
import anzyzLegalLogo from "../../../images/tranlogo_h__y_kvalitet_white_.png"
//css
import "./HeaderStyle.css"
import { getNotification, updateNotification } from "../../../actions/headerActions"
import moment from "moment"
import { getReviewListRequest, setIsCaseAdmin, setReview } from "../../../actions/reviewActions"

const useStyles = makeStyles((theme) => ({
	MenuItem: {
		width: "100%",
		padding: "22px",
		border: `solid 1px ${theme.palette.grey.D400}`,
		"&.MuiBox-root": {
			display: "flex",
		},
		"&:focus": {
			"& .MuiListItemIcon-root, & .MuiListItemText-primary": {
				color: theme.palette.common.white,
			},
		},
	},
	customBadge: {
		backgroundColor: theme.palette.primary.dark,
		paddingTop: "3px",
	},
	reviewName: {
		textDecoration: "none",
		color: theme.palette.primary.dark,
		"&:hover": {
			textDecoration: "underline",
			color: theme.palette.primary.dark,
		},
	},
}))

const StyledMenu = withStyles((theme) => ({
	paper: {
		border: `solid 1px ${theme.palette.grey.D400}`,
		borderBottom: `solid 1px none`,
		"& .MuiList-padding": {
			padding: 0,
		},
	},
}))((props) => (
	<Menu
		elevation={0}
		PaperProps={{
			style: {
				width: 600,
				maxHeight: 600,
				overflowY: "auto",
			},
		}}
		getContentAnchorEl={null}
		anchorOrigin={{
			vertical: "bottom",
			horizontal: "center",
		}}
		transformOrigin={{
			vertical: "top",
			horizontal: "center",
		}}
		{...props}
	/>
))

const StyledMenuItem = withStyles((theme) => ({
	root: {
		width: "100%",
		padding: "15px",
		border: `solid 1px ${theme.palette.grey.D400}`,
		"&.Mui-selected": {
			backgroundColor: theme.palette.grey.D500,
			"&:hover": {
				backgroundColor: theme.palette.grey.D500,
			},
		},
		"& .MuiBox-root": {
			display: "flex",
		},
		"&:focus": {
			"& .MuiListItemIcon-root, & .MuiListItemText-primary": {
				color: theme.palette.common.white,
			},
		},
	},
}))(MenuItem)

const NotificationView = () => {
	const [t] = useTranslation("global")
	const theme = useTheme()
	const classes = useStyles()
	const dispatch = useDispatch()
	let history = useHistory()
	const location = useLocation()
	const [anchorElUser, setAnchorElUser] = useState(null)
	const multiBaseList = useSelector((state) => state.multiBase.multiBaseList)
	const { user } = useSelector((state) => state?.authtentication)
	const { notification } = useSelector((state) => state?.headerReducers)
	const reviewList = useSelector((state) => state.review?.list)

	const handleOpenUserMenu = (event) => {
		setAnchorElUser(event.currentTarget)
	}

	const handleCloseUserMenu = (item) => {
		if (item?.id !== undefined) {
			dispatch(updateNotification([item?.id]))
		}
		setAnchorElUser(null)
	}

	function stringToColor(string) {
		let hash = 0
		let i
		for (i = 0; i < string.length; i += 1) {
			hash = string.charCodeAt(i) + ((hash << 5) - hash)
		}
		let color = "#"
		for (i = 0; i < 3; i += 1) {
			const value = (hash >> (i * 8)) & 0xff
			color += `00${value.toString(16)}`.slice(-2)
		}
		return color
	}

	var getContrast = function (hexcolor) {
		if (hexcolor.slice(0, 1) === "#") {
			hexcolor = hexcolor.slice(1)
		}
		var r = parseInt(hexcolor.substr(0, 2), 16)
		var g = parseInt(hexcolor.substr(2, 2), 16)
		var b = parseInt(hexcolor.substr(4, 2), 16)
		var yiq = (r * 299 + g * 587 + b * 114) / 1000
		return yiq >= 128 ? theme.palette.text.primary : theme.palette.background.default
	}

	const MenuProps = {
		anchorOrigin: {
			vertical: "bottom",
			horizontal: "left",
			maxWidth: "350px",
		},
		getContentAnchorEl: null,
	}
	const stringAvatar = (name) => {
		return {
			style: {
				...theme?.typography?.avtarText,
				background: stringToColor(name),
				color: getContrast(stringToColor(name)),
				width: "32px",
				height: "32px",
			},
			children: name?.split(" ")[1] ? `${name?.split(" ")[0][0]}${name?.split(" ")[1][0]}` : name?.split(" ")[0][0],
		}
	}

	useEffect(() => {
		dispatch(getNotification())
		let interval = setInterval(() => {
			dispatch(getNotification())
		}, 10000)
		return () => {
			clearInterval(interval)
		}
	}, [])

	return (
		<div className="notificationSection">
			<Box
				style={{
					ml: "20px",
					display: { md: "flex" },
				}}
			>
				<IconButton onClick={handleOpenUserMenu} style={{ p: 0 }}>
					<Badge
						badgeContent={notification?.data?.filter((i) => i.read_flag === false)?.length}
						classes={{ badge: classes.customBadge }}
					>
						<BellSVG color="action" />
					</Badge>
				</IconButton>
				<Box>
					<StyledMenu
						id="customized-menu"
						anchorEl={anchorElUser}
						keepMounted
						open={Boolean(anchorElUser)}
						onClose={handleCloseUserMenu}
					>
						<Box
							className="notificationMenuList"
							style={{
								m: 0,
								display: "flex",
								justifyContent: "space-between",
								position: "sticky",
								backgroundColor: theme.palette.common.white,
								top: 0,
								zIndex: 2,
							}}
						>
							{!_.isEmpty(notification?.data) && (
								<>
									<Typography textAlign="center" style={{ ...theme.typography.subTitle1, padding: "20px" }}>
										{t("notifications.notification")}
									</Typography>
									<Typography
										onClick={() => {
											const readFlag = notification?.data?.filter((i) => i.read_flag === false)
											const ids = readFlag.map((obj) => obj.id)
											dispatch(updateNotification(ids))
											handleCloseUserMenu()
										}}
										style={{ padding: "20px", cursor: "pointer" }}
										textAlign="center"
									>
										{t("notifications.markAsRead")}
									</Typography>
								</>
							)}
						</Box>
						{!_.isEmpty(notification?.data) ? (
							notification?.data?.map((item) => {
								return (
									<StyledMenuItem
										selected={!item?.read_flag}
										disableRipple
										onClick={() => {
											handleCloseUserMenu(item)
										}}
									>
										<Box style={{ display: "flex", width: "100%" }}>
											<Avatar alt={"A"} {...stringAvatar(`${item?.created_first_name} ${item?.created_last_name}`)} />
											<Box style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
												<Tooltip placement="top" arrow title={`${item?.text} - ${item?.review_name || "review"}`}>
													<Typography
														textAlign="center"
														style={{
															...theme.typography.subTitle1,
															padding: "0 20px",
															textOverflow: "ellipsis",
															maxWidth: "370px",
															overflow: "hidden",
														}}
													>
														{item?.text}
														<br />
														<Typography
															onClick={() => {
																history.push({
																	pathname: `/view-documents`,
																	state: {
																		reviewId: item?.context_id,
																		fromNotifications: true,
																	},
																})
																dispatch(getReviewListRequest())
															}}
															className={classes.reviewName}
														>
															{item?.review_name || "review"}
														</Typography>
													</Typography>
												</Tooltip>
												<Typography textAlign="center">
													{moment(moment.utc(item?.timestamp).local()).fromNow()}
												</Typography>
											</Box>
										</Box>
									</StyledMenuItem>
								)
							})
						) : (
							<Typography style={{ ...theme.typography.body2, margin: "20px", textAlign: "center" }}>
								{t("notifications.notificationsNotAvailable")}
							</Typography>
						)}
					</StyledMenu>
				</Box>
			</Box>
		</div>
	)
}

export default NotificationView
